import { apiClient } from '@/services';

export const RegisterService = {
  customerRegisterOrUpgrade(action, {
    addressSuffix,
    bankAccountHolder,
    bankBic,
    bankIban,
    bankName,
    bankSepaAuthorized,
    branch,
    businessName,
    city,
    cooperation,
    country,
    creditCheck,
    fax,
    id,
    phone,
    street,
    taxId,
    taxIdentificationNumber,
    tradeRegisterNumber,
    type,
    numberOfVehicle,
    email,
    website,
    zipCode,
  }) {
    let data = {
      addressSuffix,
      bankAccountHolder,
      bankBic,
      bankIban,
      bankName,
      bankSepaAuthorized,
      branch,
      businessName,
      city,
      cooperation,
      country,
      creditCheck,
      fax,
      id,
      phone,
      street,
      taxId,
      taxIdentificationNumber,
      tradeRegisterNumber,
      type,
      numberOfVehicle,
      email,
      website,
      zipCode,
    };

    if (action === 'upgrade') {
      const { id } = data;
      delete data.id;
      return apiClient.put(`/customer/${id}`, data);
    }

    delete data.id;
    return apiClient.post('/customer', data);
  },
  getCustomerInformation() {
    return apiClient.get('/customer');
  },
};
